import { CALL_API } from 'redux-api-middleware'
import { constructEndpoint, constructQueries, sorted } from '../utils/helpers'
import { SET_APP_CONTEXT_RECEIVE } from './appContext'

export const PERMISSION_CLEAR = 'permission/CLEAR'
export const PERMISSION_REQUEST = 'permission/REQUEST'
export const PERMISSION_RECEIVE = 'permission/RECEIVE'
export const PERMISSION_FAILURE = 'permission/FAILURE'
export const PERMISSION_POST_DIALOG_REQUEST = 'permission/POST_DIALOG_REQUEST'
export const PERMISSION_POST_DIALOG_RECEIVE = 'permission/POST_DIALOG_RECEIVE'
export const PERMISSION_POST_DIALOG_FAILURE = 'permission/POST_DIALOG_FAILURE'
export const PERMISSION_PUT_DIALOG_REQUEST = 'permission/PUT_DIALOG_REQUEST'
export const PERMISSION_PUT_DIALOG_RECEIVE = 'permission/PUT_DIALOG_RECEIVE'
export const PERMISSION_PUT_DIALOG_FAILURE = 'permission/PUT_DIALOG_FAILURE'
export const PERMISSION_DELETE_DIALOG_REQUEST = 'permission/DELETE_DIALOG_REQUEST'
export const PERMISSION_DELETE_DIALOG_RECEIVE = 'permission/DELETE_DIALOG_RECEIVE'
export const PERMISSION_DELETE_DIALOG_FAILURE = 'permission/DELETE_DIALOG_FAILURE'
export const PERMISSION_SINGLE_CLIENT_REQUEST = 'permission/SINGLE_CLIENT_REQUEST'
export const PERMISSION_SINGLE_CLIENT_RECEIVE = 'permission/SINGLE_CLIENT_RECEIVE'
export const PERMISSION_SINGLE_CLIENT_FAILURE = 'permission/SINGLE_CLIENT_FAILURE'

const initialState = {
  permissions: [],
  singleClientPermissions: [],
  totalCount: 0
}
let updatedPermissions
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_CONTEXT_RECEIVE:
    case PERMISSION_CLEAR:
      return {
        ...state,
        singleClientPermissions: []
      }
    case PERMISSION_DELETE_DIALOG_RECEIVE:
      updatedPermissions = state.permissions.filter(permission => {
        return permission.id !== action.meta.id
      })
      return {
        ...state,
        permissions: sorted(updatedPermissions)
      }
    case PERMISSION_POST_DIALOG_RECEIVE:
      updatedPermissions = [...state.permissions]
      updatedPermissions.unshift({...action.payload.data.item})
      return {
        ...state,
        permissions: sorted(updatedPermissions)
      }
    case PERMISSION_PUT_DIALOG_RECEIVE:
      updatedPermissions = state.permissions.map(permission => {
        return permission.id === action.payload.data.item.id ? action.payload.data.item : permission
      })
      return {
        ...state,
        permissions: sorted(updatedPermissions)
      }
    case PERMISSION_RECEIVE:
      return {
        ...state,
        permissions: sorted(action.payload.data.items),
        totalCount: action.payload.data.totalCount
      }
    case PERMISSION_SINGLE_CLIENT_RECEIVE:
      const filteredPermissions = filterPermissions(action.payload.data.items, action.meta.appId)
      return {
        ...state,
        singleClientPermissions: filteredPermissions
      }
    default:
      return state
  }
}

export function fetchPermissions(isRefreshRequired) {
  return (dispatch, getState) => {
    const queries = constructQueries(getState(), 'permission')

    return dispatch({
      [CALL_API]: {
        endpoint: constructEndpoint('/api/v1/authz/permissions', queries.join(''), isLocal()),
        method: 'GET',
        credentials: 'include',
        types: [PERMISSION_REQUEST,
          {
            type: PERMISSION_RECEIVE,
            meta: { isRefreshRequired : isRefreshRequired ? true : false }
          },
          {
            type: PERMISSION_FAILURE,
            meta: { isRefreshRequired : isRefreshRequired ? true : false }
          }
        ]
      }
    })
  }
}

export function fetchSingleClientPermissions(applicationId) {
  let appId = isLocal() ? '1' : applicationId
  return {
    [CALL_API]: {
      endpoint: isLocal() ? 'http://localhost:8080/api/v1/authz/permissions' :
        '/api/v1/authz/permissions',
      method: 'GET',
      credentials: 'include',
      types: [
        PERMISSION_SINGLE_CLIENT_REQUEST,
        { type: PERMISSION_SINGLE_CLIENT_RECEIVE, meta: { appId } },
        PERMISSION_SINGLE_CLIENT_FAILURE
      ]
    }
  }
}

export function postPermission(formValues) {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? 'http://localhost:8080/api/v1/authz/permissions' :
          '/api/v1/authz/permissions',
        method: 'POST',
        body: JSON.stringify(formValues),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [PERMISSION_POST_DIALOG_REQUEST, PERMISSION_POST_DIALOG_RECEIVE, PERMISSION_POST_DIALOG_FAILURE]
      }
    })
  }
}

export function putPermission(formValues) {
  const { applicationId, description, name } = formValues
  const bodyData = {
    applicationId,
    description,
    name
  }
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/permissions/${formValues.id}` :
          `/api/v1/authz/permissions/${formValues.id}`,
        method: 'PUT',
        body: JSON.stringify(bodyData),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [PERMISSION_PUT_DIALOG_REQUEST, PERMISSION_PUT_DIALOG_RECEIVE, PERMISSION_PUT_DIALOG_FAILURE]
      }
    })
  }
}

export function removePermission(permission) {
  const { id } = permission
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/permissions/${id}` :
          `/api/v1/authz/permissions/${id}`,
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [PERMISSION_DELETE_DIALOG_REQUEST,
          { type: PERMISSION_DELETE_DIALOG_RECEIVE, meta: { id } },
          PERMISSION_DELETE_DIALOG_FAILURE]
      }
    })
  }
}

function filterPermissions(permissions, appId) {
  const matchingPermissions = permissions.filter(permission => {
    return permission.applicationId === appId
  })
  return matchingPermissions
}

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default reducer
